// Set at login (magic link or email/password) when a non-manager user has
// never been active (lastActivity is null). The tour reads it on the next
// layout page and clears it on finish/skip.
export const ONBOARDING_TOUR_PENDING_KEY = "onboardingTourPending";

// Dispatched on window to replay the tour on demand (e.g. from the avatar menu).
export const START_ONBOARDING_TOUR_EVENT = "mple:start-onboarding-tour";

// Managers and Admin never get the tour, whichever way they sign in.
export const isOnboardingTourAllowedForRole = (role?: string | null) =>
  (role || "").toLowerCase() !== "manager" &&
  (role || "").toLowerCase() !== "admin";

export const markOnboardingTourPending = () => {
  try {
    localStorage.setItem(ONBOARDING_TOUR_PENDING_KEY, "true");
  } catch {
    // Storage unavailable: the tour is optional, so skip it silently.
  }
};

export const isOnboardingTourPending = () => {
  try {
    return localStorage.getItem(ONBOARDING_TOUR_PENDING_KEY) === "true";
  } catch {
    return false;
  }
};

export const clearOnboardingTourPending = () => {
  try {
    localStorage.removeItem(ONBOARDING_TOUR_PENDING_KEY);
  } catch {
    // ignore
  }
};

/**
 * Single place every login flow calls once it has the login response.
 * `lastActivity` is the value from before this login (the backend returns it
 * on both /users/login and /users/magic-login); only an explicit null means
 * "never active", so a missing field never triggers the tour. Clears the flag
 * otherwise, so a stale flag from an earlier session can't carry over.
 */
export const syncOnboardingTourPending = ({
  lastActivity,
  role,
  isImpersonated = false,
}: {
  lastActivity: unknown;
  role?: string | null;
  isImpersonated?: boolean;
}) => {
  if (
    lastActivity === null &&
    !isImpersonated &&
    isOnboardingTourAllowedForRole(role)
  ) {
    markOnboardingTourPending();
  } else {
    clearOnboardingTourPending();
  }
};

export const requestOnboardingTour = () => {
  window.dispatchEvent(new Event(START_ONBOARDING_TOUR_EVENT));
};
